import React, { useState, useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';

import { WysiwygField } from '../../../../components';

import './style.scss';

const ParagraphAccordionRow = ({ entity }) => {
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState({});
  const innerRef = useRef(null);

  useLayoutEffect(() => {
    if (innerRef.current) {
      setHeight({ height: open ? `${innerRef.current.offsetHeight}px` : '74px' });
    }
  }, [open]);

  return (
    <div
      className="ParagraphAccordionRow o-background--grey"
      style={height}
      onClick={() => setOpen(!open)}
    >
      <div className="ParagraphAccordionRow__inner u-padding--top-bottom--4" ref={innerRef}>
        <div className="ParagraphAccordionRow__title u-margin--bottom--4 h5">
          {entity.getIn(['field_title', 0, 'value'])}
        </div>
        <div className={classNames(
          'ParagraphAccordionRow__toggle',
          'u-margin--5',
          'icon',
          open ? 'icon-remove' : 'icon-add',
        )}>
          {open ? 'close' : 'open'}
        </div>
        <WysiwygField
          property="schema:text"
          className="ParagraphText"
          html={entity.getIn(['field_text', 0, 'processed'])}
        />
      </div>
    </div>
  );
};

export default ParagraphAccordionRow;
